import Modals from './modals/modals';
import Calendar from './calendar/calendar';
import CalendarGrid from './calendarGrid/calendarGrid';
import CalendarFilters from './calendarFilters/calendarFilters';
import CalendarContextMenu from './calendarContextMenu/calendarContextMenu';
import calendarComponent from './calendarComponent/calendarComponent';
import calendarInline from './calendarInlineComponent/calendarInline/calendarInline';
import calendarHeader from  './calendarInlineComponent/calendarInlineHeader/calendarInlineHeader';
import calendarCard from './calendarInlineComponent/calendarInlineCard/calendarInlineCard';
import calendarPaginator from './calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator';
import calendarHide from './calendarInlineComponent/calendarInlineHide/calendarInlineHide';
import HolidaySummary from './holidaySummary/holidaySummary';
import warnLastDay from './warnLastDay/warnLastDay';
import EmployeeAfk from './employeeAfk/employeeAfk';
import employeeSearchTags from './employeeSearchTags/employeeSearchTags';
import sicknessLeaveDate from './sicknessLeaveDate/sicknessLeaveDate';

let vacationsAbsencesComponents = angular.module('vacations-absences.components', [
  Modals,
  Calendar,
  CalendarGrid,
  CalendarFilters,
  CalendarContextMenu,
  calendarComponent,
  calendarInline,
  calendarHeader,
  calendarCard,
  calendarPaginator,
  calendarHide,
  HolidaySummary,
  warnLastDay,
  EmployeeAfk,
  employeeSearchTags,
  sicknessLeaveDate
])

.name;

export default vacationsAbsencesComponents;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/vacations-absences.components.js